import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/components/Main'
import Quick from '@/components/controls/Quick'
import Menu from '@/components/controls/Menu'
import Devices from '@/components/devices/active/Devices'
import MapSettings from '@/components/user/settings/Map'
import LanguageSettings from '@/components/user/settings/Language'
import Settings from '@/components/user/Settings'
import Device from '@/components/devices/active/Device'
import DeviceOptions from '@/components/devices/active/DeviceOptions'
import NewDevice from '@/components/devices/new/NewDevice'
import NewDeviceOptions from '@/components/devices/new/NewDeviceOptions'
import QRScanner from '@/components/devices/new/QRScanner'
import NewReport from '@/components/reports/NewReport'
import Report from '@/components/reports/Report'
import Reports from '@/components/reports/Reports'
import SettingsReports from '@/components/reports/SettingsReports'
import Events from '@/components/events/Events'
import Auth from '@/components/user/Auth'
import Login from '@/components/user/Login'
// import Register from '@/components/user/Register'
import Recover from '@/components/user/Recover'
import store from '../store'
import i18n from '../localization'

const isNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const isAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/sign/in')
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '/',
          name: 'Quick',
          component: Quick
        },
        {
          path: '/menu',
          name: 'Menu',
          component: Menu,
          children: [
            {
              path: 'events',
              name: 'events',
              component: Events,
              props: (route) => ({ query: route.query.type }),
              meta: { tr: 'events.main_label' }
            },
            {
              path: 'devices',
              name: 'devices',
              component: Devices,
              meta: { tr: 'devices.main_label' }
            },
            {
              path: 'device/:id',
              name: 'device',
              component: Device,
              meta: { tr: 'devices.single.main_label' }
            },
            {
              path: 'device/:id/options',
              name: 'device_options',
              component: DeviceOptions,
              meta: { tr: 'devices.optional.main_label' }
            },
            {
              path: 'reports/settings/add',
              name: 'new_report',
              component: NewReport,
              meta: { tr: 'reports.add.main_label' }
            },
            {
              path: 'reports/settings/edit/:id',
              name: 'edit_report',
              component: Report,
              meta: { tr: 'reports.edit.main_label' }
            },
            {
              path: 'reports',
              name: 'reports',
              component: Reports,
              meta: { tr: 'reports.main_label' }
            },
            {
              path: 'reports/settings',
              name: 'settings_reports',
              component: SettingsReports,
              meta: { tr: 'reports.settings_label' }
            },
            {
              path: 'new',
              name: 'device_new',
              component: NewDevice,
              meta: { tr: 'devices.add.main_label' }
            },
            {
              path: 'new/options',
              name: 'device_new_options',
              component: NewDeviceOptions,
              meta: { tr: 'devices.optional.main_label' }
            },
            {
              path: 'new/qr',
              name: 'qr_scan',
              component: QRScanner,
              meta: { tr: 'devices.add.scan_qr_label' }
            },
            {
              path: 'settings',
              name: 'settings',
              component: Settings,
              meta: { tr: 'settings.main_label' }
            },
            {
              path: 'settings/map',
              name: 'settings_map',
              component: MapSettings,
              meta: { tr: 'settings.map_mng_label' }
            },
            {
              path: 'settings/language',
              name: 'settings_lang',
              component: LanguageSettings,
              meta: { tr: 'language.main_label' }
            },
            {
              path: '*',
              name: 'unknown_comp',
              meta: { tr: 'unknown.main_label' }
            }
          ]
        }
      ],
      beforeEnter: isAuthenticated
    },
    {
      path: '/sign',
      component: Auth,
      children: [
        {
          path: 'in',
          name: 'Login',
          component: Login
        },
        // {
        //   path: 'up',
        //   component: Register
        // },
        {
          path: 'restore',
          component: Recover
        },
        {
          path: '*',
          component: Login
        }
      ],
      beforeEnter: isNotAuthenticated
    },
    {
      path: '*',
      component: Vue.component('page-not-found', {
        template: '',
        created () {
          window.location.href = '404'
        }
      })
    }
  ]
})

router.beforeEach((to, from, next) => {
  to.meta.alias = i18n.t(to.meta.tr)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js